import { AdminLookupKeyEnum, AdminSearchEpdRequest, AdminEpdSearchResult, Option } from 'types/types';
import { AdminCompanySearchRequest } from 'types/admin-search-companies/AdminCompanySearchRequest';
import { AdminCompanySearchResultItem } from 'types/admin-search-companies/AdminCompanySearchResultItem';
import { axiosInstance } from './apiCommon';
import { PagedResult } from 'types/search-common/PagedResult';

export const getAdminLookup = async (key: AdminLookupKeyEnum): Promise<Option[]> => {
  const response = await axiosInstance.get<Option[]>(`/api/admin/v1/AdminLookups/${encodeURIComponent(key)}`);
  return response.data;
};

export const searchEpds = async (request: AdminSearchEpdRequest) => {
  const response = await axiosInstance.post<PagedResult<AdminEpdSearchResult>>(`/api/admin/v1/AdminEPDs/search`, request);
  return response.data;
};

export const updateAgent = async (epdVersionId: string, agentId: string) => {
  await axiosInstance.put(`/api/admin/v1/AdminEPDs/agent`, {
    epdVersionId: epdVersionId,
    agentId: agentId,
  });
};

export const getAdminIlcdEpdBundle = async (epdVersionId: string) => {
  return await axiosInstance.get(`/api/admin/v1/AdminEPDs/DownloadILCDEPD`, {
    responseType: 'blob',
    params: {
      id: epdVersionId,
      shouldMockMissingData: true,
    },
  });
};

export const postSearchCompanies = async (param: AdminCompanySearchRequest) =>
  (await axiosInstance.post<PagedResult<AdminCompanySearchResultItem>>('/api/admin/v1/AdminCompanies/search', param)).data;
